import React from 'react'
import PropTypes from 'prop-types'
import { Loader } from 'belle-js'
import LoadingPage from '../LoadingPage/LoadingPage'

const PageContainer = (props) => {
  const {
    children,
    isInitialLoad,
    isLoading
  } = props

  const loadingState = isInitialLoad ? <LoadingPage /> : <Loader />

  return (
    <div data-test="pageContainer">
      {(isInitialLoad || isLoading) ? loadingState : children}
    </div>
  )
}

PageContainer.defaultProps = {
  isInitialLoad: false,
  isLoading: false
}

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isInitialLoad: PropTypes.bool,
  isLoading: PropTypes.bool
}

export default PageContainer



// WEBPACK FOOTER //
// ./src/components/Client/PageContainer/PageContainer.jsx